export type ErrorMessageOption<T> = string | ((value: T) => string)

export function getErrorMessage<T>(
    errorMessage: ErrorMessageOption<T> | undefined,
    defaultMessage: string,
    value: T
): string {
    if (!errorMessage) {
        return defaultMessage
    }

    return typeof errorMessage === 'function' ? errorMessage(value) : errorMessage
}
